<template>
  <section class="mt-8 mb-4 boxed-button-grid" v-if="modelValue">
    <input type="radio" :value="null" id="null_risk" v-model="modelValue.risk" name="riskOption" class="hidden" />
    <label
      v-for="risk in riskOptions"
      :key="risk"
      class="base-button"
      :class="{
        active: hasRisk(risk),
      }"
      >{{ wt('risk', 'option', risk) }}
      <input
        type="radio"
        :value="risk"
        :id="risk"
        v-model="modelValue.risk"
        name="riskOption"
        @click="onRiskClick(risk)" />
    </label>
  </section>
  <textarea
    v-if="modelValue"
    class="core-form-textarea"
    id="description"
    placeholder="..."
    v-model.lazy="modelValue.riskRemarks"
    rows="5"
    cols="25"
    :class="{
      'core-form-error': validator.getErrors('risk_remarks'),
    }" />
  <ErrorMessage name="risk_remarks" class="error-message" />
</template>

<script lang="ts" setup generic="T extends { risk?: string; riskRemarks?: string }">
import { toRef, type PropType } from 'vue'
import { Risk } from '@/schemas/general/enums'
import ErrorMessage from '@/components/shared/ErrorMessage.vue'
import { useValidator } from '@/validation/form-validator'
import { useWidgetText } from '@/helpers/useWidgetText'

const props = defineProps<{
  role?: string
}>()

const modelValue = defineModel({ type: Object as PropType<T> })

const { wt } = useWidgetText('widget-texts-project-setup', toRef(props, 'role'))
const validator = useValidator()
const riskOptions = Object.values(Risk)

const hasRisk = function (risk: Risk): boolean {
  return modelValue.value?.risk === risk
}

const onRiskClick = function (risk: Risk): void {
  if (hasRisk(risk) && modelValue.value) {
    delete modelValue.value.risk
  }
}
</script>

<style lang="postcss" scoped></style>
